module.exports = __webpack_public_path__ + "static/media/Hasura.c49a1dc7.svg";